import { render } from "./HeaderButton.vue?vue&type=template&id=7ef344ce&scoped=true&ts=true"
import script from "./HeaderButton.vue?vue&type=script&lang=ts"
export * from "./HeaderButton.vue?vue&type=script&lang=ts"

import "./HeaderButton.vue?vue&type=style&index=0&id=7ef344ce&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef344ce"]])

export default __exports__